import React from "react";
import { useIntl } from "react-intl";
import { BaseLayout, Header, NoData } from "../components";
import { useCongress } from "../hooks";
import { ReactComponent as SocialWallSvg } from "../assets/icons/social wall.svg";

const SocialWallPage = () => {
  const intl = useIntl();
  const { congress } = useCongress();

  return (
    <BaseLayout>
      <Header
        icon={SocialWallSvg}
        title={intl.formatMessage({
          id: "Pages.SocialWallPage.Social Wall",
          defaultMessage: "Social Wall"
        })}
      />
      <NoData data={congress.wallIoUrl}>
        <iframe
          allowFullScreen
          id="wallsio-iframe"
          src={congress.wallIoUrl}
          style={{ border: 0, height: "800px", width: "100%" }}
          loading="lazy"
          title={`${congress.name} social wall`}
        />
      </NoData>
    </BaseLayout>
  );
};

export default SocialWallPage;
